"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("@voyage/multi/voyageMessageIds");
var crokinole_gameSync_sidecar_1 = require("./crokinole_gameSync-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Crokinole_SimulationFrame;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.gameSyncNumber);
    messageWriter_sidecar_1.messageWriter.write32(m, d.frame);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_discs);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_misc);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.drift_discs);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        gameSyncNumber: messageWriter_sidecar_1.messageWriter.read16(m),
        frame: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_discs: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_misc: messageWriter_sidecar_1.messageWriter.read32(m),
        drift_discs: messageWriter_sidecar_1.messageWriter.readFloat(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        gameSyncNumber: 1549,
        frame: 12046,
        crc_discs: 524202158,
        crc_misc: 4586789,
        drift_discs: 0.00000000234,
    };
    messageWriter_sidecar_1.messageWriter.test('simulationFrame', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    // console.log('process simulation frame')
    var msg = read(m);
    var frame = msg.frame;
    // console.log('set simulation frame', frame, isFromHost)
    // TODO: make sure this is from the host? Doesn't seem to work with self-sent messages
    //if (isFromHost) {
    if (msg.gameSyncNumber !== websockets_sidecar_1.websockets.getGameSyncNumber()) {
        console.log('game sync number mismatch, updating');
        websockets_sidecar_1.websockets.setGameSyncNumber(msg.gameSyncNumber);
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().gameSyncNumber = msg.gameSyncNumber;
        // Acknolwedge game sync number to the host
        crokinole_gameSync_sidecar_1.crokinole_gameSync.sendMessageToHost({
            gameSyncNumber: websockets_sidecar_1.websockets.getGameSyncNumber(),
        });
    }
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.addCrcCheckToBuffer(msg);
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().frameTimeAccumulator_waitingForNextFrame =
        false;
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().simulateToFrame = frame;
    // websockets.setSimulationFrame(frame)
    //}
    // Add to crc check
    // console.log('add crc check')
    // TODO: need to sync crc checks?
    // let cur = voyageMultiplayerCursors.findByMultiIdSafe(fromId)
    // if (cur) {
    //   voyageMultiplayerCursors.networkRecieveStartLerpToXY(cur, msg.x, msg.y)
    // }
}
exports.process = process;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendMessageToAll = sendMessageToAll;
